import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { RepeatersPageConfig } from '../types'
import type { Component, RepeaterDataItem } from '@wix/thunderbolt-becky-types'
import { isDisplayedOnly, isRepeaterComponent } from '@wix/thunderbolt-commons'
import { name } from '../symbols'

const isTemplateRepeater = (component: Component, compId: string): boolean =>
	isRepeaterComponent(component) && !isDisplayedOnly(compId)

const repeatersPageConfig: PageConfigFn<RepeatersPageConfig> = ({ api }: VsmContext) => {
	const repeaterComponents = api.components.getComponentsByPredicate(isTemplateRepeater)
	const repeaterIds = Object.keys(repeaterComponents)

	if (repeaterIds.length === 0) {
		return { shouldLoadPageFeature: false }
	}

	const repeatersData: RepeatersPageConfig['repeatersData'] = {}

	for (const repeaterCompId of repeaterIds) {
		const descendants = api.components.getCompDescendants(repeaterCompId)
		if (descendants.length === 0) {
			continue
		}

		const compData = api.components.getCompData<RepeaterDataItem>(repeaterCompId)
		const childComponents: Record<string, string> = {}
		for (const childCompId of descendants) {
			if (childCompId.endsWith('_relative') || childCompId.endsWith('_pinned')) {
				continue
			}
			const childStructure = api.components.getStructure(childCompId)
			if (childStructure) {
				childComponents[childCompId] = childStructure.componentType
			}
		}

		const items = compData?.items ?? []

		repeatersData[repeaterCompId] = { childComponents, items }
	}

	if (Object.keys(repeatersData).length === 0) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: { repeatersData },
	}
}

export const pageConfig: PageConfigEntry<RepeatersPageConfig> = {
	name,
	configFactory: repeatersPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
